import React from 'react';

import { ErrorLabel } from '@eika/label';

interface ErrorMessageLabelProps {
    errorMessage: string | undefined;
    errorId: string;
}

const ErrorMessageLabel = ({ errorMessage, errorId }: ErrorMessageLabelProps): JSX.Element => {
    if (errorMessage) {
        return (
            <ErrorLabel className="sgw-radio-button-error-label" id={errorId} aria-live="polite" text={errorMessage} />
        );
    }
    return <span id={errorId} role="alert" />;
};

export default ErrorMessageLabel;
